import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon24: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#73C177"
        d="M15.5 0a.5.5 0 0 1 .5.5v1.503l1.5.001a2.5 2.5 0 0 1 2.5 2.5v13.002a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5V4.504a2.5 2.5 0 0 1 2.5-2.5L4 2.003V.5a.5.5 0 0 1 1 0v1.503h10V.5a.5.5 0 0 1 .5-.5ZM19 8.027H1v9.479a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V8.027Zm-5.16 2.607a.5.5 0 0 1 .025.707l-4.662 5a.5.5 0 0 1-.725.007l-2.337-2.415a.5.5 0 0 1 .719-.695l1.97 2.036 4.304-4.615a.5.5 0 0 1 .706-.025ZM4 3.003l-1.5.001a1.5 1.5 0 0 0-1.5 1.5v2.523h18V4.504a1.5 1.5 0 0 0-1.5-1.5L16 3.003V4.5a.5.5 0 0 1-1 0V3.003H5V4.5a.5.5 0 0 1-1 0V3.003Z"
      />
    </Svg>
  )
}
